import { useState} from "react";
import NoteContext from "./noteContext";

const NoteState = (props) => {
  const host = "https://noteboss-backend.onrender.com";
  const notesInitial = [];
  
  const [notes, setNotes] = useState(notesInitial);

  // ****Fetch Request for Notes****
  const [updateErrorCount, setUpdateErrorCount] = useState(0)
  const updateNotes = async () => {
    try {
      props.showLoading()
      const url = `${host}/api/notes/fetchallnotes`;
      const response = await fetch(url, {
        headers: {
          "auth-token": localStorage.getItem('auth-token')
        },
        method: "GET",  
      });
      const data = await response.json();
      let status = response.status;
      props.completeLoading()
      if(status === 401){
        props.showAlert("danger","Error","UnAuthorised Person... Please Re-Login Try Again")
        localStorage.removeItem('auth-token')
        window.location.reload();
      }else{
        setNotes(data);
      }
    } catch (error) {
      if(updateErrorCount===0){
        setUpdateErrorCount(1)
        updateNotes();
      }else if(updateErrorCount===1){
        props.showAlert("danger","Error","Some Internal Error Occurred... Please Try Again Later")
        setUpdateErrorCount(0)
      }
    }
  };
  
  // Adding New Note
  const addNote = async (title, description, tag = "General") => {
    try {
      // API Call
      const url = `${host}/api/notes/createnewnotes`;
      // eslint-disable-next-line
      const response = await fetch(url, {
        headers: {
          "auth-token":localStorage.getItem("auth-token"),
          "content-type": "application/json",
        },
        method: "POST",
        body: JSON.stringify({ title, description, tag }),
      });
      let status = response.status;
      if(status === 401){
        props.showAlert("danger","Error","UnAuthorised Person... Please Re-Login Try Again")
      }else if(status === 400){
        props.showAlert("danger","Error","Some Bad Request Occured... Please Try Again")
      }else if(status === 500){
        props.showAlert("danger","Error","Some DataBase Internal Error Occured... Please Try Again")
      }else{
        props.showAlert("success","Success","Note Added Successfully")
      }
    } catch (error) {
      props.showAlert("danger","Error","Some Internal Error Occured... Please Try Again Later")
    }
  };

  // Edit a Note
  const editNote = async (noteId, title, description, tag = "General") => {
    try {
      // API Call
      const url = `${host}/api/notes/updatenotes/${noteId}`;
      // eslint-disable-next-line
      const response = await fetch(url, {
        headers: {
          "auth-token":localStorage.getItem("auth-token"),
          "content-type": "application/json",
        },
        method: "PUT",
        body: JSON.stringify({ title, description, tag }),
      }); 
      let status = response.status;
      if(status === 404){
        props.showAlert("danger","Error","NoteId/Url Mismatched... Please Try Again Later")
      }else if(status === 401){
        props.showAlert("danger","Error","UnAuthorised Person... Please Re-Login Try Again")
      }else if(status === 400){
        props.showAlert("danger","Error","Some Bad Request Occured... Please Try Again")
      }else if(status === 500){
        props.showAlert("danger","Error","Some DataBase Internal Error Occured... Please Try Again")
      }else{
        updateNotes();
        props.showAlert("success","Success",`Note Edited Successfully`)
      }
    } catch (error) {
      props.showAlert("danger","Error","Some Internal Error Occured... Please Try Again Later")
    }
  };
  // Deleting a Note
  const deleteNote = async (noteId) => {
    try {
      // API Call
      const url = `${host}/api/notes/deletenote/${noteId}`;
      // eslint-disable-next-line
      const response = await fetch(url, {
        headers: {
          "auth-token":localStorage.getItem("auth-token"),
        },
        method: "DELETE",
      });
      let status = response.status;
      if(status === 404){
        props.showAlert("danger","Error","NoteId/Url Mismatched... Please Try Again Later")
      }else if(status === 401){
        props.showAlert("danger","Error","UnAuthorised Person... Please Re-Login Try Again")
      }else if(status === 400){
        props.showAlert("danger","Error","Some Bad Request Occured... Please Try Again")
      }else if(status === 500){
        props.showAlert("danger","Error","Some DataBase Internal Error Occured... Please Try Again")
      }else{
        updateNotes();
      }
    } catch (error) {
      props.showAlert("danger","Error","Some Internal Error Occured... Please Try Again Later")
    }
  };

  // Find A Note By ID
  const findNoteById = async (noteId) => {
    try {
      // API Call
      const url = `${host}/api/notes/fetchallnotes`;
      const response = await fetch(url, {
        headers: {
          "auth-token":localStorage.getItem("auth-token"),
        },
        method: "GET",
      });

      let data = await response.json();
      let availableNote = data.filter((e) => {
        return e._id === noteId;
      });
      let status = response.status;
      if(status === 401){
        props.showAlert("danger","Error","UnAuthorised Person... Please Re-Login Try Again")
      }else if(status === 500){
        props.showAlert("danger","Error","Some DataBase Internal Error Occured... Please Try Again")
      }else{
        return availableNote[0];
      }
    } catch (error) {
      props.showAlert("danger","Error","Some Internal Error Occured... Please Try Again Later")
    }
  };

  return (
    <NoteContext.Provider
      value={{
        notes,
        addNote,
        editNote,
        deleteNote,
        updateNotes,
        findNoteById,
      }}
    >
      {props.children}
    </NoteContext.Provider>
  );
};

export default NoteState;
